export default class HttpInterceptor {
  transform(options) {
    throw Error('Virtual method');
  }

  handleError({ statusCode, data }) {
    if (statusCode === 0) {
      alert('Server probably down');
    }

    return Promise.reject({ statusCode, data });
  }

  handleSuccess({ statusCode, data }) {
    return { statusCode, data };
  }
}
